import { tableColumnsList } from '@op/pages/Compare/ChannelShareRanking/constants';
import { formatTime } from '../renderHelper';
import { DownloadConfigInfoType } from '../types';

export const MarketPopularityRankingTrend: DownloadConfigInfoType = { 
  columns: ({ filter }) => {
    const tableColumns: any = [
      {
        header: 'Game',
        key: 'entity_name',
      },
      {
        header: 'Date',
        key: 'time',
        renderHelper: [formatTime(filter)],
      },
      ...tableColumnsList.map((item) => {
        if (item.value !== 'market_share_by_view') {
          return {
            header: item.text,
            key: item.value,
          };
        }

        return {
          header: item.text,
          key: item.value,
          numFmt: '0.00%',
        };
      }),
    ];

    return tableColumns;
  },
};
